import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Nurse = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="nurse icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M0 19.7744C15 8.07518 33 8.07523 48 19.7744L41 38C32 33.84 16 33.84 7 38C4.8606 33.057 1.99257 25.2766 0.692383 21.6953L0 19.7744ZM45.5918 20.4638C31.9505 10.5069 16.0191 10.5132 2.38086 20.4834C2.44019 20.6474 2.50386 20.8243 2.57227 21.0127C3.0041 22.2021 3.60966 23.8566 4.30371 25.7158C5.4519 28.7914 6.83461 32.4014 8.07129 35.3926C12.6636 33.6906 18.3862 32.8799 24 32.8799C29.5887 32.8799 35.2853 33.6836 39.8672 35.3701L45.5918 20.4638ZM26 21H30V25H26V29H22V25H18V21H22V17H26V21Z"
    />
  </svg>
)
